import { render, staticRenderFns } from "./preparation-memos.vue?vue&type=template&id=ba9f6cee&scoped=true&"
import script from "./preparation-memos.vue?vue&type=script&lang=js&"
export * from "./preparation-memos.vue?vue&type=script&lang=js&"
import style0 from "./preparation-memos.vue?vue&type=style&index=0&id=ba9f6cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9f6cee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectCustom: require('/opt/cargo.front/src/components/select/custom.vue').default,BaseLayoutPageHeader: require('/opt/cargo.front/src/components/base/layout/page-header.vue').default,BookingPreparationSteps: require('/opt/cargo.front/src/components/booking/preparation-steps.vue').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default})
